import * as React from 'react'
import type { LucideIcon } from 'lucide-react'
import {
  Camera,
  Clock,
  Mail,
  PenLine,
  Phone,
  Send,
  Share2,
  Sparkles,
  Store,
  Sun,
  Tag,
  TramFront,
  Trees,
  VolumeX,
} from 'lucide-react'

// Canned data (LOCATION_HIGHLIGHTS, My-listings suggestions, contact chips)
// stores Material Symbol names from the prototype; production renders lucide.
const MATERIAL_TO_LUCIDE: Record<string, LucideIcon> = {
  directions_transit: TramFront,
  park: Trees,
  wb_sunny: Sun,
  storefront: Store,
  volume_off: VolumeX,
  sell: Tag,
  schedule: Clock,
  edit_note: PenLine,
  share: Share2,
  mail: Mail,
  call: Phone,
  send: Send,
  photo_camera: Camera,
}

export interface MIconProps {
  name: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export function MIcon({ name, size = 14, className, style }: MIconProps) {
  const Ico = MATERIAL_TO_LUCIDE[name] ?? Sparkles
  return <Ico size={size} className={className} style={style} />
}
